<template>
  <div>
    <dara-form v-if="department" :submit="save">
      <div class="form-field mt-5">
        <dara-input
          v-model="department.name"
          :label="$t('departments-name') + '*'"
          :name="$t('department-name-field')"
          type="text"
          rules="required|min:2"
          :placeholder="$t('department-name-placeholder')" />
      </div>
      <div class="form-field">
        <dara-input
          v-model="department.description"
          :label="$t('description')"
          :name="$t('description-field')"
          type="text"
          :placeholder="$t('department-description-placeholder')" />
      </div>
      <div class="mt-4 mb-3 d--flex justify-content-end">
        <dara-button
          class="btn btn-secondary"
          width="110"
          size="sm"
          @click="goHistoryBack()">
          {{ $t('cancel') }}
        </dara-button>
        <dara-button
          native-type="submit"
          class="btn btn-success ms-2"
          width="110"
          size="sm">
          <span v-if="department.id">{{ $t('update') }}</span>
          <span v-else>{{ $t('save') }}</span>
        </dara-button>
      </div>
    </dara-form>
  </div>
</template>

<script>
import { goHistoryBack } from '@/router/route.service';

export default {
  name: 'DaraDepartmentEdit',
  inject: ['departmentEditVm'],
  data() {
    return {
      department: this.departmentEditVm.department,
    };
  },
  methods: {
    goHistoryBack,
    save() {
      this.$emit('save');
    },
  },
};
</script>
